import React from "react";
import "./Leetcode.css";

function Leetcode() {
  return (
    <>
      <h5>My leetcode</h5>
      <div className="leetcode-status">
        <iframe
          src="https://leetcode.com/ltlkong/"
          width="100%"
          height="100%"
          seamless="seamless"
        />
      </div>
    </>
  );
}

export default Leetcode;
